import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Suppress the dev error overlay & console noise for expected network/HTTP errors
// (e.g. 401 from auth-gated endpoints while logged out). These are handled by the app
// and must never blanket the UI. Registered first so it runs before the CRA overlay.
const isAxiosError = (r) => !!(r && (r.isAxiosError || r.name === "AxiosError" || (r.config && r.request)));
window.addEventListener(
  "unhandledrejection",
  (e) => {
    if (isAxiosError(e.reason)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
